import React from 'react';
import { Loader, Text } from 'src/@vymo/ui/atoms';
import { trimString } from '../../queries';
import { TileData } from '../../types';
import styles from '../../index.module.scss';

function TextTile({
  data,
  onClick,
  index,
  isLoading,
}: {
  data: { tile: TileData; links: Record<string, any> };
  onClick: (
    data: { tile: TileData; links: Record<string, any> },
    index: number,
  ) => void;
  index: number;
  isLoading: boolean;
}) {
  return (
    <div
      key={data?.tile?.code}
      className={`${styles.spg__tile} ${styles.spg__tile__text_only}`}
    >
      <div
        className={styles.spg__icon}
        onClick={() => onClick(data, index)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick(data, index);
          }
        }}
        tabIndex={0}
        role="button"
        aria-label={`${data?.tile?.name} tile`}
      >
        {isLoading ? (
          <Loader />
        ) : (
          <Text type="label">{trimString(data?.tile?.name, 20)}</Text>
        )}
      </div>
    </div>
  );
}

export default TextTile;
